export default interface Entity {
  id: string;
  createdBy: string;
  createdAt: number;
  lastModifiedBy?: string;
  lastModified?: number;
}
